import { GarageTypeApi } from "../generated/FahrzeugdatenGarageTypeApi";
import { AppUtils } from '../../utils/index';
/**
 * Model for an differing account owner for the iban calculator sub application.
 */
export class FahrzeugModel {
	private id: string;
	private baureihe: string;
	private baureiheId: string;
	private baureihengeneration: string;
	private baureihengenerationId: string;
	private fahrzeugart: GarageTypeApi;
	private fahrzeugtitel: string;
	private fahrzeugbezeichnung: string;
	private farbe: number;
	private karosserievariante: string;
	private auslOderDiplomat: boolean;
	private kennzeichenPrefix: string;
	private kennzeichenSuffix: string;
	private kraftstoff: number;
	private kraftstoffArt: string;
	private marke: string;
	private markeId: string;
	private modell: string;
	private modellId: string;
	private schadstoffklasse: number;
	private verbrauch: number;
	private verbrauchGesamtMitEinheit: string;
	private verbrauchGesamtWltpMitEinheit: string;
	private tetId: string;
	private kfzId: string;
	private isManuallyChanged: boolean;
	private grundpreisMitEinheit: string;
	private leistungKw: number;
	private leistungPs: string;
	private hubraumMitEinheit: string;
	private bildAltText: string;
	private bildDateiName: string;

	public get ID(): string {
		if (this.id) {
			return this.id;
		}
		let result: string = null;
		if (this.kennzeichenPrefix || this.kennzeichenSuffix) {
			result = "";
			if (this.kennzeichenPrefix) {
				result = this.kennzeichenPrefix;
			}
			if (this.kennzeichenSuffix) {
				if (0 < result.length) {
					result += "-";
				}
				result += this.kennzeichenSuffix;
			}
		}
		return result;
	}
	public set ID(value: string) {
		this.id = value;
	}

	/**
	 * TetId - parameter to set the Kraftstoff .
	 */
	set TetId(value: string) {
		this.tetId = value;
	}

	/**
	 * TetId - get the optional Kraftstoff.
	 */
	get TetId(): string {
		return this.tetId;
	}

	/**
	 * Kraftstoff - parameter to set the Kraftstoff .
	 */
	set Kraftstoff(value: number) {
		this.kraftstoff = value;
	}

	/**
	 * Kraftstoff - get the optional Kraftstoff.
	 */
	get Kraftstoff(): number {
		return this.kraftstoff;
	}

	/**
	 * KraftstoffArt - parameter to set the KraftstoffArt .
	 */
	set KraftstoffArt(value: string) {
		this.kraftstoffArt = value;
	}

	/**
	 * KraftstoffArt - get the optional KraftstoffArt.
	 */
	get KraftstoffArt(): string {
		return this.kraftstoffArt;
	}

	/**
	 * Farbe - parameter to set the Farbe .
	 */
	set Farbe(value: number) {
		this.farbe = value;
	}

	/**
	 * Farbe - get the optional Farbe.
	 */
	get Farbe(): number {
		return this.farbe;
	}

	/**
	 * FahrzeugTitel - parameter to set the FahrzeugTitel .
	 */
	set FahrzeugTitel(value: string) {
		this.fahrzeugtitel = value;
	}

	/**
	 * FahrzeugTitel - get the optional FahrzeugTitel.
	 */
	get FahrzeugTitel(): string {
		return this.fahrzeugtitel;
	}

	/**
	 * FahrzeugBezeichnung - parameter to set the Fahrzeugbezeichnung.
	 */
	set FahrzeugBezeichnung(value: string) {
		this.fahrzeugbezeichnung = value;
	}

	/**
	 * FahrzeugBezeichnung - get the optional Fahrzeugbezeichnung.
	 */
	get FahrzeugBezeichnung(): string {
		return this.fahrzeugbezeichnung;
	}

	/**
	 * Fahrzeugart - parameter to set the Fahrzeugart .
	 */
	set Fahrzeugart(value: GarageTypeApi) {
		this.fahrzeugart = value;
	}

	/**
	 * Fahrzeugart - get the optional Fahrzeugart.
	 */
	get Fahrzeugart(): GarageTypeApi {
		return this.fahrzeugart;
	}

	/**
	 * Marke - parameter to set the Marke .
	 */
	set Marke(value: string) {
		this.marke = value;
	}

	/**
	 * Marke - get the optional Marke.
	 */
	get Marke(): string {
		return this.marke;
	}

	set MarkeId(value: string) {
		this.markeId = value;
	}

	get MarkeId(): string {
		return this.markeId;
	}

	/**
	 * Baureihe - parameter to set the Baureihe .
	 */
	set Baureihe(value: string) {
		this.baureihe = value;
	}

	/**
	 * Baureihe - get the optional Baureihe.
	 */
	get Baureihe(): string {
		return this.baureihe;
	}


	set BaureiheId(value: string) {
		this.baureiheId = value;
	}

	get BaureiheId(): string {
		return this.baureiheId;
	}

	/**
	 * BaureiheGeneration, parameter to set the Baureihengeneration.
	 */

	set BaureiheGeneration(value: string) {
		this.baureihengeneration = value;
	}

	/**
	 * BaureiheGeneration, get the optional Baureihengeneration.
	 */
	get BaureiheGeneration(): string {
		return this.baureihengeneration;
	}

	set BaureiheGenerationId(value: string) {
		this.baureihengenerationId = value;
	}

	get BaureiheGenerationId(): string {
		return this.baureihengenerationId;
	}

	/**
	 * Modell - parameter to set the Modell .
	 */
	set Modell(value: string) {
		this.modell = value;
	}

	/**
	 * Modell - get the optional Modell.
	 */
	get Modell(): string {
		return this.modell;
	}


	get ModellId(): string {
		return this.modellId;
	}

	set ModellId(value: string) {
		this.modellId = value;
	}
	/**
	 * Karosserievariante - parameter to set the Karosserievariante .
	 */
	set Karosserievariante(value: string) {
		this.karosserievariante = value;
	}

	/**
	 * Karosserievariante - get the optional Karosserievariante.
	 */
	get Karosserievariante(): string {
		return this.karosserievariante;
	}

	/**
	 * AuslOderDiplomat - sets if the Kennzeichen is foreign or diplomat
	 */
	set AuslOderDiplomat(value: boolean) {
		this.auslOderDiplomat = value;
	}

	/**
	 * AuslOderDiplomat - returns true if the Kennzeichen is foreign or diplomat
	 */
	get AuslOderDiplomat(): boolean {
		return this.auslOderDiplomat;
	}

	/**
	 * KennzeichenPrefix - parameter to set the KennzeichenPrefix .
	 */
	set KennzeichenPrefix(value: string) {
		this.kennzeichenPrefix = value;
	}

	/**
	 * KennzeichenPrefix - get the optional KennzeichenPrefix.
	 */
	get KennzeichenPrefix(): string {
		return this.kennzeichenPrefix;
	}

	/**
	 * KennzeichenSuffix - parameter to set the KennzeichenSuffix .
	 */
	set KennzeichenSuffix(value: string) {
		this.kennzeichenSuffix = value;
	}

	/**
	 * KennzeichenSuffix - get the optional KennzeichenSuffix.
	 */
	get KennzeichenSuffix(): string {
		return this.kennzeichenSuffix;
	}

	/**
	 * Verbrauch - parameter to set the Verbrauch .
	 */
	set Verbrauch(value: number) {
		this.verbrauch = value;
	}

	/**
	 * Verbrauch - get the optional Verbrauch.
	 */
	get Verbrauch(): number {
		return this.verbrauch;
	}

	/**
	 * VerbrauchGesamtMitEinheit - parameter to set the VerbrauchGesamtMitEinheit .
	 */
	set VerbrauchGesamtMitEinheit(value: string) {
		this.verbrauchGesamtMitEinheit = value;
	}

	/**
	 * VerbrauchGesamtMitEinheit - get the optional VerbrauchGesamtMitEinheit.
	 */
	get VerbrauchGesamtMitEinheit(): string {
		return this.verbrauchGesamtMitEinheit;
	}

	/**
	 * VerbrauchGesamtWltpMitEinheit - parameter to set the VerbrauchGesamtWltpMitEinheit .
	 */
	set VerbrauchGesamtWltpMitEinheit(value: string) {
		this.verbrauchGesamtWltpMitEinheit = value;
	}

	/**
	 * VerbrauchGesamtWltpMitEinheit - get the optional VerbrauchGesamtWltpMitEinheit.
	 */
	get VerbrauchGesamtWltpMitEinheit(): string {
		return this.verbrauchGesamtWltpMitEinheit;
	}

	/**
	 * Schadstoffklasse - parameter to set the Schadstoffklasse .
	 */
	set Schadstoffklasse(value: number) {
		this.schadstoffklasse = value;
	}

	/**
	 * Schadstoffklasse - get the optional Schadstoffklasse.
	 */
	get Schadstoffklasse(): number {
		return this.schadstoffklasse;
	}

	/**
	 * KfzId  - parameter to set the KfzId  .
	 */
	set KfzId(value: string) {
		this.kfzId = value;
	}

	/**
	 * KfzId  - get the optional KfzId .
	 */
	get KfzId(): string {
		return this.kfzId;
	}

	/**
	 * IsManuallyChanged  - parameter to set the IsManuallyChanged  .
	 */
	set IsManuallyChanged(value: boolean) {
		this.isManuallyChanged = value;
	}

	/**
	 * IsManuallyChanged  - get the optional IsManuallyChanged .
	 */
	get IsManuallyChanged(): boolean {
		return this.isManuallyChanged;
	}

	/**
	 * GrundpreisMitEinheit  - parameter to set the GrundpreisMitEinheit  .
	 */
	set GrundpreisMitEinheit(value: string) {
		this.grundpreisMitEinheit = value;
	}

	/**
	 * GrundpreisMitEinheit  - get the optional GrundpreisMitEinheit .
	 */
	get GrundpreisMitEinheit(): string {
		return this.grundpreisMitEinheit;
	}

	get LeistungKw(): number {
		return this.leistungKw;
	}
	set LeistungKw(value: number) {
		this.leistungKw = value;
	}

	get LeistungPs(): string {
		return this.leistungPs;
	}
	set LeistungPs(value: string) {
		this.leistungPs = value;
	}

	get HubraumMitEinheit(): string {
		return this.hubraumMitEinheit;
	}
	set HubraumMitEinheit(value: string) {
		this.hubraumMitEinheit = value;
	}

	get BildAltText(): string {
		return this.bildAltText;
	}
	set BildAltText(value: string) {
		this.bildAltText = value;
	}

	get BildDateiName(): string {
		return this.bildDateiName;
	}
	set BildDateiName(value: string) {
		this.bildDateiName = value;
	}

	/**
	 * Creates a new AbwKontoInhaberModel object and copies the values from the provided data object (or other AbwKontoInhaber model) to the created AbwKontoInhaberModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): FahrzeugModel {
		return AppUtils.Helper.createFromMap(dataObject, FahrzeugModel);
	}
}